import * as React from "react";
const SvgFiRrCoffin = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-coffin_svg__a)">
      <path
        fill="#062147"
        d="m20.627 6.731-1.436-3.588a4.98 4.98 0 0 0-4.643-3.144H9.506a4.98 4.98 0 0 0-4.643 3.143L3.427 6.731a6 6 0 0 0-.305 3.444l2.035 9.837a5.02 5.02 0 0 0 4.896 3.987h3.944a5.02 5.02 0 0 0 4.896-3.987l2.035-9.837a6 6 0 0 0-.305-3.445zM18.973 9.77l-2.035 9.838A3.01 3.01 0 0 1 14.001 22h-3.944a3.01 3.01 0 0 1-2.938-2.392L5.084 9.771a4 4 0 0 1 .203-2.296l1.436-3.589A2.98 2.98 0 0 1 9.508 2h5.042c1.234 0 2.327.74 2.785 1.886l1.436 3.588c.293.732.363 1.526.203 2.296"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-coffin_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCoffin;
